module.exports = __webpack_public_path__ + "img/agriculture-careers.8bbaf04f.jpg";